<template>
  <v-carousel cycle
              height="400"
              hide-delimiter-background
              show-arrows-on-hover
  >
    <v-carousel-item
        v-for="(project, i) in projects"
        :key="i"
    >
      <v-sheet
          :color="project.color"
          height="100%"
      >
        <v-img v-if="project.img" :src="'./img/projects/'+project.img" class="fill-height pa-1">
          <v-row
              class="fill-height"
              align="center"
              justify="center"
          >
            <div class="text-center pl-2 pr-2"
                 :class="projectClass(project)">{{
                project.content
              }}
            </div>
          </v-row>
        </v-img>
        <v-row
            class="fill-height"
            align="center"
            justify="center"
            v-else
        >
          <div
              class="text-center pl-2 pr-2"
              :class="projectClass(project)">{{
              project.content
            }}
          </div>
        </v-row>
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: "Projects",
  data() {
    return {
      projects: [
        {
          content: 'Santé publique : Comprendre ce que c\'est ',
          color: 'indigo',
          img: 'ufr.jpg',
          textcolor: 'green',
        },
        {
          content: 'Sport Santé : Sensibiliser le public',
          color: 'warning',
          img: '',
          textcolor: 'deep-purple accent-4',
        },
        {
          content: 'Rencontrer les nouveaux professionnels de santé',
          color: 'green  ligthen-2',
          textcolor: 'blue'
        },
        {
          content: 'Osons parler du surpoids',
          color: 'pink darken-2',
          img: 'efs.png',
          textcolor: 'red darken-2',
        },
        {
          content: 'Les enfants et leurs dents',
          color: 'yellow darken-2',
          textcolor: 'indigo'
        },
        {
          content: "Et bien d'autres à venir...",
          color: 'red lighten-1',
          img: '',
          textcolor: 'white--text',
        },
        {
          content: '... contactez-nous pour proposer le votre !',
          color: 'deep-purple accent-4',
          img: '',
          textcolor: 'white--text',
        }

      ],

    }
  },
  methods: {
    projectClass(project) {
      let sizeClass = this.$vuetify.breakpoint.mdAndUp ? ' display-3' : ' display-1'
      return project.textcolor + ' ' + sizeClass
    }
  }
}
</script>

<style scoped>

</style>